module.exports = __webpack_public_path__ + "img/features-hour.59760d60.png";